/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1PersonIdPhoto200,
  PostApiV1PersonIdPhoto400,
  PostApiV1PersonIdPhoto401,
  PostApiV1PersonIdPhoto404,
  PostApiV1PersonIdPhoto500,
  PostApiV1PersonIdPhotoMutationRequest,
  PostApiV1PersonIdPhotoMutationResponse,
  PostApiV1PersonIdPhotoPathParams,
} from "../../types/personRegisterController/PostApiV1PersonIdPhoto.ts";

export const postApiV1PersonIdPhotoPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1PersonIdPhotoPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1PersonIdPhoto200Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdPhoto200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1PersonIdPhoto400Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdPhoto400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1PersonIdPhoto401Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdPhoto401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1PersonIdPhoto404Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdPhoto404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1PersonIdPhoto500Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdPhoto500>;

export const postApiV1PersonIdPhotoMutationRequestSchema = z.object({
  file: z.optional(z.instanceof(File)),
}) as unknown as ToZod<PostApiV1PersonIdPhotoMutationRequest>;

export const postApiV1PersonIdPhotoMutationResponseSchema = z.lazy(
  () => postApiV1PersonIdPhoto200Schema,
) as unknown as ToZod<PostApiV1PersonIdPhotoMutationResponse>;
